import { createAction } from 'redux-actions';

export default {
	UpdateGridsCfg: createAction('UPDATE_GRIDS_CFG'),
	UpdateCurrentGrid: createAction('UPDATE_CURRENT_GRID')
};
